// state = profile state / location state / etc
// conditions = requirements found in ./location - ./product - ./profile

export default function (state, conditions, modelName) {
  const errors = [];
  let total = 0;
  let negative = 0;

  Object.keys(conditions).forEach(key => {
    const condition = conditions[key];
    // check if condition is only for accom / nonaccom  or supplier / contractor
    if (!Array.isArray(condition.only) || condition.only.indexOf(modelName === 'profile' ? state.type : state.productType) !== -1) {
      // pass state value into object-types and check if typeof is correct
      const conditionResults = condition.type(state[key], state);
      // if array is returned (things like contacts), then check each one
      // false means it did not meet the typeof condition in object-types
      // undefined means it passed
      if (Array.isArray(conditionResults)) {
        conditionResults.forEach(error => {
          if (error.warning) {
            negative += error.value;
            errors.push({
              warning: error.warning,
              scrollTo: error.scrollTo,
            });
          }
        });
        total += (conditionResults.length || 1);
      } else {
        total += (condition.progressValue || 1);
        if (conditionResults === false) {
          negative += condition.progressValue;
          errors.push({
            warning: condition.warning,
            scrollTo: condition.scrollTo,
          });
        }
      }
    }
  });

  return {
    errors,
    percentage: Math.floor((total - negative) / total * 100),
  };
}



// WEBPACK FOOTER //
// ./src/app/utils/marketing-readiness/validator.js